import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Journey from "./pages/Journey";
import Expertise from "./pages/Expertise";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import CreateResume from "./pages/tools/CreateResume";
import PasswordGenerator from "./pages/tools/PasswordGenerator/PasswordGenerator";
import ThicknessCalculator from "./pages/tools/ThicknessCalculator";
import WeldDefectChecker from "./pages/tools/WeldDefectChecker";
import ResumePage from "./pages/ResumePage";
import ToolsDashboard from "./pages/Tools";
import ScrollToTop from "./components/ScrollToTop";
import PasswordHistory from "./pages/tools/PasswordGenerator/PasswordHistory";
import AdvancedPasswordPage from "./pages/tools/PasswordGenerator/AdvancedPassword";
import TempPasswordPage from "./pages/tools/PasswordGenerator/TempPasswordPage";
import ToolsFooter from "./pages/tools/ToolsFooter";
import QRCodeGenerator from "./pages/tools/QrGenerator/QRCodeGenerator";
import QRStyling from "./pages/tools/QrGenerator/QRStyling";
import QRTypes from "./pages/tools/QrGenerator/QRTypes";
import FileToQR from "./pages/tools/QrGenerator/FiletoQR";

import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Ventures from "./pages/Ventures";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { toolsData } from "./Data/ToolsData";
import { DynamicToolLoader } from "./components/DynamicToolLoader";
import MovieFinder from "./pages/tools/MovieFinder/MovieFinder";
// import DiwaliBanner from "./pages/DiwaliBanner";

function AppWrapper() {
  const location = useLocation();

  // 1. Check if the current route is a dynamic tool from your Data file
  const isDynamicTool = toolsData.some(tool => tool.url === location.pathname);
  
  // 2. Static tools routes that still use ToolsFooter
  const toolsRoutes = [
    "/tools",
    "/createresume",
    "/passwordgenerator",
    "/passwordhistory",
    "/advancedpassword",
    "/qrgenerator",
    "/thicknesscalculator",
    "/weldchecker",
    "/qrstyling",
    "/qrtypes",
    "/filetoqr",
    "/moviefinder"
  ];

  const isExactTool = toolsRoutes.includes(location.pathname);
  const isTempRoute = location.pathname.startsWith("/temp/");

  // 3. LOGIC GATES
  // Hide Navbar/Footer for EVERYTHING inside toolsData (Dynamic)
  const hideEverything = isDynamicTool; 
  
  // Decide which footer to show for non-dynamic pages
  const isToolsPage = isExactTool || isTempRoute;

  return (
    <>
      <ScrollToTop />
      
      {/* Navbar: Hidden if it's a dynamic tool OR a static tool page */}
      {!hideEverything && !(isExactTool || isTempRoute) && <Navbar />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/journey" element={<Journey />} />
        <Route path="/expertise" element={<Expertise />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/resume" element={<ResumePage />} />
        <Route path="/services" element={<Services />} />
        <Route path="/ventures" element={<Ventures />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />

        {/* Tools pages */}
        <Route path="/tools" element={<ToolsDashboard />} />
        <Route path="/createresume" element={<CreateResume />} />
        <Route path="/passwordgenerator" element={<PasswordGenerator />} />
        <Route path="/passwordhistory" element={<PasswordHistory />} />
        <Route path="/advancedpassword" element={<AdvancedPasswordPage />} />
        <Route path="/qrgenerator" element={<QRCodeGenerator />} />
        <Route path="/qrstyling" element={<QRStyling />} />
        <Route path="/qrtypes" element={<QRTypes />} />
        <Route path="/filetoqr" element={<FileToQR />} />
        <Route path="/thicknesscalculator" element={<ThicknessCalculator />} />
        <Route path="/weldchecker" element={<WeldDefectChecker />} />
        <Route path="/temp/:id" element={<TempPasswordPage />} />
        <Route path="/moviefinder" element={<MovieFinder />} />

        {/* The Dynamic Route */}
        <Route path="/:toolPath" element={<DynamicToolLoader />} />
      </Routes>

      {/* FOOTER LOGIC */}
      {!hideEverything && (
        isToolsPage ? <ToolsFooter /> : <Footer />
      )}

      <ToastContainer theme="colored" />
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}
